<template>
  <div>
    <h1>960 Grid System mit flexiblen Spalten</h1>
    <div class="container_12">
      <h2>12-Spalten-Raster</h2>
      <div class="grid_3">
        <p>22.9166667 %</p>
      </div>
      <div class="grid_9">
        <p>42 %</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlexibleDesignView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
@import "./normalize.css";
@import "./demo.css";
@import "./960-flexible.css";

.container_12 {
  margin-left: auto;
  margin-right: auto;
}

.grid_3,
.grid_9 {
  display: inline;
  float: left;
  margin-left: 1.041666666666667%;
  margin-right: 1.041666666666667%;
  border-style: solid;
}

.container_12 .grid_3 {
  width: 22.91666666666667%;
}

.container_12 .grid_9 {
  /* width: 72.91666666666667%; */
  width: 42%;
}

.container_12:before,
.container_12:after {
  content: ".";
  display: block;
  overflow: hidden;
  visibility: hidden;
  font-size: 0;
  line-height: 0;
  width: 0;
  height: 0;
}

.container_12:after {
  clear: both;
}

.container_12 {
  zoom: 1;
}

.container_12 {
  background-image: url(./12_col.gif);
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/examples/flexible-design/flexible-design.vue